(function () {
  function parseId(value) {
    var id = parseInt(value, 10);
    return Number.isFinite(id) && id > 0 ? id : null;
  }

  function getUpsellRoot() {
    return document.querySelector('[data-revahs-upsells]');
  }

  function getSelectedUpsells() {
    var root = getUpsellRoot();
    if (!root) return [];

    return Array.from(
      root.querySelectorAll(
        '.revahs-upsell-card:not([hidden]) input[data-upsell-variant-id]:checked'
      )
    );
  }

  function getMainQuantity() {
    var selectors = [
      'input[name="quantity"]',
      '[data-pf-type="ProductQuantity"] input',
      '.pf-quantity input'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el) continue;

      var qty = parseInt(el.value, 10);
      if (Number.isFinite(qty) && qty > 0) return qty;
    }

    return 1;
  }

  function getSelectedUpgradeCard() {
    var selectors = [
      '.revahs-upg__card.is-selected[data-variant-id]',
      '.revahs-upg__card[aria-checked="true"][data-variant-id]',
      '.revahs-upg__option.is-selected[data-variant-id]',
      '.revahs-upg__card.is-active[data-variant-id]',
      '.revahs-upg__card.selected[data-variant-id]',
      '[data-selected-model="true"][data-variant-id]',
      '.is-selected[data-variant-id]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }

    return null;
  }

  function getVariantFromUpgradeSelector() {
    var selectedCard = getSelectedUpgradeCard();
    if (!selectedCard) return null;

    return parseId(
      selectedCard.getAttribute('data-variant-id') || selectedCard.dataset.variantId
    );
  }

  function getVariantTypeFromUpgradeSelector() {
    var selectedCard = getSelectedUpgradeCard();
    if (!selectedCard) return null;

    var explicitType =
      selectedCard.getAttribute('data-upgrade-type') ||
      selectedCard.dataset.upgradeType ||
      selectedCard.getAttribute('data-model-type') ||
      selectedCard.dataset.modelType;

    if (explicitType) {
      explicitType = String(explicitType).toLowerCase();
      if (explicitType === 'base' || explicitType === 'pro') return explicitType;
    }

    var rawText = (
      (selectedCard.getAttribute('data-title') || '') +
      ' ' +
      (selectedCard.getAttribute('aria-label') || '') +
      ' ' +
      (selectedCard.textContent || '')
    ).toLowerCase();

    if (rawText.indexOf('pro') > -1) return 'pro';

    return 'base';
  }

  function getVariantFromNativeInputs() {
    var selectors = [
      'form[action*="/cart/add"] input[name="id"]',
      'form[action*="/cart/add"] select[name="id"]',
      'input[name="id"]',
      'select[name="id"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el) continue;

      var value = el.value || el.getAttribute('value');
      var id = parseId(value);
      if (id) return id;
    }

    return null;
  }

  function getVariantFromButton(button) {
    if (!button) return null;

    return parseId(
      button.getAttribute('data-variant-id') ||
      button.dataset.variantId ||
      button.getAttribute('data-product-variant-id') ||
      button.dataset.productVariantId
    );
  }

  function getMainVariantId(button) {
    var fromUpgrade = getVariantFromUpgradeSelector();
    if (fromUpgrade) return fromUpgrade;

    var fromNative = getVariantFromNativeInputs();
    if (fromNative) return fromNative;

    var fromButton = getVariantFromButton(button);
    if (fromButton) return fromButton;

    return null;
  }

  function getCurrentUpsellGroup() {
    var root = getUpsellRoot();
    if (!root) return null;

    var selectedType = getVariantTypeFromUpgradeSelector();
    if (selectedType === 'base' || selectedType === 'pro') return selectedType;

    var fallback = root.getAttribute('data-default-group');
    if (fallback === 'base' || fallback === 'pro') return fallback;

    return 'base';
  }

  function syncUpsellVisibility() {
    var root = getUpsellRoot();
    if (!root) return;

    var activeGroup = getCurrentUpsellGroup();
    if (!activeGroup) return;

    root.setAttribute('data-active-group', activeGroup);

    var cards = Array.from(root.querySelectorAll('.revahs-upsell-card[data-upsell-group]'));
    cards.forEach(function (card) {
      var cardGroup = (card.getAttribute('data-upsell-group') || '').toLowerCase();
      var isActive = cardGroup === activeGroup;
      var input = card.querySelector('input[data-upsell-variant-id]');

      card.hidden = !isActive;
      card.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      if (!isActive && input) {
        input.checked = false;
      }
    });

    var groupContents = Array.from(root.querySelectorAll('[data-upsell-content-group]'));
    groupContents.forEach(function (el) {
      var group = (el.getAttribute('data-upsell-content-group') || '').toLowerCase();
      var isActive = group === activeGroup;

      el.hidden = !isActive;
      el.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  function buildItems(button) {
    var items = [];
    var mainVariantId = getMainVariantId(button);
    var quantity = getMainQuantity();

    if (!mainVariantId) return items;

    items.push({
      id: mainVariantId,
      quantity: quantity
    });

    getSelectedUpsells().forEach(function (checkbox) {
      var upsellId = parseId(checkbox.getAttribute('data-upsell-variant-id'));
      if (!upsellId) return;

      items.push({
        id: upsellId,
        quantity: 1
      });
    });

    return items;
  }

  async function addItems(items) {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin'
    });

    if (!response.ok) {
      var text = await response.text().catch(function () {
        return '';
      });
      throw new Error('Cart add failed: ' + text);
    }

    return response.json();
  }

  async function refreshAndOpenDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    document.dispatchEvent(new CustomEvent('revahs:cart:add:complete'));

    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('cart:open'));
    }, 220);
  }

  function setLoading(button, state) {
    if (!button) return;

    if (state) {
      button.disabled = true;
      button.classList.add('is-loading');

      if (!button.dataset.revahsOriginalHtml) {
        button.dataset.revahsOriginalHtml = button.innerHTML;
      }

      if (button.dataset.adding) {
        button.innerHTML = button.dataset.adding;
      }
    } else {
      button.disabled = false;
      button.classList.remove('is-loading');

      if (button.dataset.revahsOriginalHtml) {
        button.innerHTML = button.dataset.revahsOriginalHtml;
      }
    }
  }

  function shouldIntercept(button) {
    if (!button) return false;
    if (getUpsellRoot()) return true;
    return false;
  }

  async function handleAddToCart(button, event) {
    if (!shouldIntercept(button)) {
      return;
    }

    syncUpsellVisibility();

    var items = buildItems(button);
    if (!items.length) {
      return;
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    setLoading(button, true);

    try {
      await addItems(items);
      await refreshAndOpenDrawer();
    } catch (error) {
      console.error('REVAHS upsell add error:', error);
    } finally {
      setLoading(button, false);
    }
  }

  function getMainAtcButtons() {
    return Array.from(document.querySelectorAll('[data-pf-type="ProductATC2"]'));
  }

  function getStickyAtcButtons() {
    return Array.from(
      document.querySelectorAll(
        '.Vtl-StickyAddToCart__AddToCartButton, #bundle-sticky_add_to_cart-root .Vtl-StickyAddToCart__AddToCartButton'
      )
    );
  }

  function bindMainButtons() {
    var buttons = getMainAtcButtons();
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      if (button.dataset.revahsUpsellsBound === 'true') return;
      button.dataset.revahsUpsellsBound = 'true';

      button.addEventListener(
        'click',
        function (event) {
          handleAddToCart(button, event);
        },
        true
      );
    });
  }

  function bindStickyButtons() {
    var buttons = getStickyAtcButtons();
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      if (button.dataset.revahsStickyBound === 'true') return;
      button.dataset.revahsStickyBound = 'true';

      button.addEventListener(
        'click',
        function (event) {
          handleAddToCart(button, event);
        },
        true
      );
    });
  }

  function bindVariantSync() {
    if (document.body.dataset.revahsUpsellSyncBound === 'true') return;
    document.body.dataset.revahsUpsellSyncBound = 'true';

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest(
        '.revahs-upg__card, .revahs-upg__option, [data-variant-id], [data-selected-model]'
      );

      if (!trigger) return;

      setTimeout(syncUpsellVisibility, 0);
      setTimeout(syncUpsellVisibility, 80);
      setTimeout(syncUpsellVisibility, 220);
    });

    document.addEventListener('change', function () {
      setTimeout(syncUpsellVisibility, 0);
    });

    document.addEventListener('variant:change', function () {
      syncUpsellVisibility();
    });

    document.addEventListener('revahs:upgrade:changed', function () {
      syncUpsellVisibility();
    });
  }

  function init() {
    bindMainButtons();
    bindStickyButtons();
    bindVariantSync();
    syncUpsellVisibility();

    var observer = new MutationObserver(function () {
      bindMainButtons();
      bindStickyButtons();
      syncUpsellVisibility();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();